import { OpenerComponent } from "../common"
import { DuetLangObject } from "./language-utils"
import { getElementsFromDefaultSlot } from "./slot-utils"

type ariaPopup = "true" | "menu" | "listbox" | "tree" | "grid" | "dialog"

interface A11yLabel {
  element: HTMLElement
  accessibleLabel?: string
  external?: boolean
  accessibleLabelExternal?: DuetLangObject | string
  accessibleLabelDownload?: DuetLangObject | string
  download?: string
}

export function getAccessibleLinkLabel(component: A11yLabel) {
  const textContent = component.element.textContent

  if (component.accessibleLabel) {
    return component.accessibleLabel
  }
  if ((!!component.download || component.download === "") && textContent) {
    return `${textContent}. ${component.accessibleLabelDownload}.`
  }
  if (component.external && textContent) {
    return `${textContent}. ${component.accessibleLabelExternal}.`
  }
  if (getElementsFromDefaultSlot(component.element).length) {
    return textContent
  }
  return null
}

/**
 * An element that controls open/close state of a Duet component can itself be either a Duet component or an HTML element,
 * this helper handles the setting of the relevant attributes accordingly.
 *
 * @param el Duet component or HTML element that is used for controlling the popup
 * @param expanded is the controlled element open
 * @param popup The type of the popup, defaults to "true" which equals to "menu"
 */
export function setOpenerExpanded(el: OpenerComponent | HTMLElement, expanded: boolean, popup: ariaPopup = "true") {
  const isDuetComponent = el.tagName.toLowerCase().startsWith("duet-")
  if (isDuetComponent) {
    const comp = el as OpenerComponent
    comp.accessiblePopup = popup
    comp.accessibleExpanded = expanded
  } else {
    el.setAttribute("aria-haspopup", popup)
    el.ariaExpanded = String(!!expanded)
  }
}
